/* eslint-disable no-use-before-define */
/* eslint-disable camelcase, max-len */

import { passiveSupported } from "../util/support";

const Carousel = (function Carousel() {
  let carousel;
  let slides;
  let index;
  let slidenav;
  let settings;
  let timer;
  let animationSuspended;
  let navClicked;

  function forEachElement(elements, fn) {
    for (let i = 0; i < elements.length; i += 1) {
      fn(elements[i], i);
    }
  }

  function removeClass(el, className) {
    if (el.classList) {
      el.classList.remove(className);
    } else {
      el.className = el.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
    }
  }

  function hasClass(el, className) {
    if (el.classList) {
      return el.classList.contains(className);
    }
    return new RegExp(`(^| )${className}( |$)`, 'gi').test(el.className);
  }

  function init(set) {
    settings = set;
    const container = settings.element;
    carousel = container.querySelector('.carousel');
    slides = carousel.querySelectorAll('.slide');
    navClicked = false;

    slides.forEach((slide) => {
      const imgSrc = slide.dataset.imgSrc;
      if (imgSrc) {
        // eslint-disable-next-line no-param-reassign
        slide.style.backgroundImage = `url("${imgSrc}")`;
      }
    });

    carousel.classList.add('active');

    const ctrlsPrev = document.createElement('ul');

    ctrlsPrev.className = 'controls';
    ctrlsPrev.innerHTML = '<li>'
      + '<button type="button" class="btn-prev"><i class="fa fa-2x fa-chevron-left"></i><span class="sr-only">Previous item</span> </button>'
      + '</li>';

    ctrlsPrev.querySelector('.btn-prev')
      .addEventListener('click', () => {
        prevSlide(true);
      });

    carousel.appendChild(ctrlsPrev);

    if (settings.slidenav || settings.animate) {
      slidenav = document.createElement('ul');

      slidenav.className = 'slidenav';

      const slidenavselectors = document.createElement('li');
      slidenavselectors.className = 'slidenavselectors';

      if (settings.animate) {
        const li = document.createElement('li');
        if (settings.startAnimated) {
          li.innerHTML = '<button data-action="stop"><span class="sr-only">Stop Animation </span><i class="fas fa-pause"></i></button>';
        } else {
          li.innerHTML = '<button data-action="start"><span class="sr-only">Start Animation </span><i class="fas fa-play"></i></button>';
        }
        li.className = 'slidenavstartstop';
        slidenav.appendChild(li);
      }

      if (settings.slidenav) {
        const ul = document.createElement('ul');

        forEachElement(slides, (el, i) => {
          const li = document.createElement('li');
          const klass = (i === 0) ? 'class="current" ' : '';
          const kurrent = (i === 0) ? ' <span class="sr-only">(Current Item)</span>' : '';
          const ariaCurrent = (i === 0) ? ' aria-current="true" ' : '';

          li.innerHTML = `<button ${klass}${ariaCurrent}data-slide="${i}"><span class="sr-only">News</span> ${i + 1}${kurrent}</button>`;
          ul.appendChild(li);
        });

        ul.className = 'slideList';
        slidenavselectors.appendChild(ul);
        slidenav.appendChild(slidenavselectors);
      }

      slidenav.addEventListener('click', (event) => {
        const button = event.target;
        if (button.localName === 'button') {
          if (button.getAttribute('data-slide')) {
            stopAnimation();
            setSlides(button.getAttribute('data-slide'), true);
            navClicked = true;
          } else if (button.getAttribute('data-action') === 'stop') {
            stopAnimation();
          } else if (button.getAttribute('data-action') === 'start') {
            startAnimation();
          }
        }
      }, true);

      carousel.className = 'active carousel with-slidenav';
      carousel.appendChild(slidenav);
    }

    const liveregion = document.createElement('div');
    liveregion.setAttribute('aria-live', 'polite');
    liveregion.setAttribute('aria-atomic', 'true');
    liveregion.setAttribute('class', 'liveregion sr-only');
    carousel.appendChild(liveregion);

    const ctrlsNext = document.createElement('ul');

    ctrlsNext.className = 'controls';
    ctrlsNext.innerHTML = '<li>'
      + '<button type="button" class="btn-next"><i class="fa fa-2x fa-chevron-right"></i><span class="sr-only">Next item</span> </button>'
      + '</li>';

    ctrlsNext.querySelector('.btn-next')
      .addEventListener('click', () => {
        nextSlide(true);
      });

    carousel.appendChild(ctrlsNext);

    slides[0].parentNode.addEventListener('transitionend', (event) => {
      const slide = event.target;
      removeClass(slide, 'in-transition');
      if (navClicked) {
        for (let i = 0; i < slides.length; i += 1) {
          if (hasClass(slides[i], 'current')) {
            slides[i].setAttribute('tabindex', '-1');
            slides[i].focus();
          }
        }
        navClicked = false;
      }

      /* if (hasClass(slide, 'current'))  {
        if(setFocus) {
          slide.setAttribute('tabindex', '-1');
          slide.focus();
          //setFocus = false;
        }
      } */
    });

    carousel.addEventListener('mouseenter', suspendAnimation);
    carousel.addEventListener('mouseleave', () => {
      if (animationSuspended) {
        startAnimation();
      }
    });

    carousel.addEventListener('focusin', (event) => {
      if (!hasClass(event.target, 'slide')) {
        suspendAnimation();
      }
    });
    carousel.addEventListener('focusout', (event) => {
      if (!hasClass(event.target, 'slide') && animationSuspended) {
        startAnimation();
      }
    });

    index = 0;
    setSlides(index, true);

    if (settings.startAnimated) {
      timer = setTimeout(nextSlide, 5000);
    }
  }

  /**
   * @param {number} new_current
   * @param {boolean} setFocusHere
   * @param {('next'|'prev'|'none')} transition
   * @param {boolean} announceItemHere
   */
  function setSlides(new_current, setFocusHere, transition: 'next'|'prev'|'none' = 'none', announceItemHere?: boolean) {
    const announceItem = typeof announceItemHere !== 'undefined' ? announceItemHere : false;
    const new_current_flag = parseFloat(new_current);

    const length = slides.length;
    let new_next = new_current_flag + 1;
    let new_prev = new_current_flag - 1;

    if (new_next === length) {
      new_next = 0;
    }
    if (new_prev < 0) {
      new_prev = length - 1;
    }

    slides[new_next].className = `next slide${(transition === 'next') ? ' in-transition' : ''}`;
    slides[new_next].setAttribute('aria-hidden', 'true');

    slides[new_prev].className = `prev slide${(transition === 'prev') ? ' in-transition' : ''}`;
    slides[new_prev].setAttribute('aria-hidden', 'true');

    slides[new_current_flag].className = 'current slide';
    slides[new_current_flag].removeAttribute('aria-hidden');

    if (announceItem) {
      carousel.querySelector('.liveregion').textContent = `Item ${new_current_flag + 1} of ${slides.length}`;
    }

    if (settings.slidenav) {
      const buttons = carousel.querySelectorAll(':scope .slidenav button[data-slide]');
      for (let j = buttons.length - 1; j >= 0; j--) {
        buttons[j].className = '';
        buttons[j].innerHTML = `<span class="sr-only">News</span> ${j + 1}`;
        buttons[j].removeAttribute('aria-current');
      }
      buttons[new_current_flag].className = 'current';
      buttons[new_current_flag].innerHTML = `<span class="sr-only">News</span> ${new_current_flag + 1} <span class="sr-only">(Current Item)</span>`;
      buttons[new_current_flag].setAttribute('aria-current', 'true');
    }

    index = new_current_flag;

    const slidenavselectors = carousel.querySelector('.slidenavselectors');
    let slideButtonWidth = 50; // default
    const current = carousel.querySelector('.slidenav button.current');
    const slideButtonListItemStyle = window.getComputedStyle(current.parentElement);
    slideButtonWidth = parseFloat(slideButtonListItemStyle.width) + parseFloat(slideButtonListItemStyle.marginRight) + parseFloat(slideButtonListItemStyle.marginLeft);

    const slidebounds = slidenavselectors.getBoundingClientRect();
    if ((current.offsetLeft + current.offsetWidth) > (slidebounds.width + slidenavselectors.scrollLeft)) {
      slidenavselectors.scrollLeft += slideButtonWidth;
    }

    if (current.offsetLeft < slidenavselectors.scrollLeft) {
      slidenavselectors.scrollLeft = -slidenavselectors.scrollLeft;
    }
  }

  function nextSlide(announceItem?: boolean) {
    const notNullAnnouceItem = typeof announceItem !== 'undefined' ? announceItem : false;

    const length = slides.length;
    let new_current = index + 1;

    if (new_current === length) {
      new_current = 0;
    }

    setSlides(new_current, false, 'prev', notNullAnnouceItem);

    if (settings.animate) {
      clearTimeout(timer); // make sure we don't get loads happening at once
      timer = setTimeout(nextSlide, 5000);
    }
  }

  function prevSlide(announceItem?: boolean) {
    const notNullAnnounceItem = typeof announceItem !== 'undefined' ? announceItem : false;

    const length = slides.length;
    let new_current = index - 1;

    if (new_current < 0) {
      new_current = length - 1;
    }

    clearTimeout(timer);
    setSlides(new_current, false, 'next', notNullAnnounceItem);
  }

  function stopAnimation() {
    clearTimeout(timer);
    settings.animate = false;
    animationSuspended = false;
    const _this = carousel.querySelector('[data-action]');
    _this.innerHTML = '<span class="sr-only">Start Animation </span><i class="fas fa-play"></i>';
    _this.setAttribute('data-action', 'start');
  }

  function startAnimation() {
    settings.animate = true;
    animationSuspended = false;
    timer = setTimeout(nextSlide, 5000);
    const _this = carousel.querySelector('[data-action]');
    _this.innerHTML = '<span class="sr-only">Stop Animation </span><i class="fas fa-pause"></i>';
    _this.setAttribute('data-action', 'stop');
  }

  function suspendAnimation() {
    if (settings.animate) {
      clearTimeout(timer);
      settings.animate = false;
      animationSuspended = true;
    }
  }

  return {
    init,
    next: nextSlide,
    prev: prevSlide,
    goto: setSlides,
    stop: stopAnimation,
    start: startAnimation,
  };
});

export function init(element) {
  const c = Carousel();
  c.init({
    element,
    slidenav: true,
    animate: true,
    startAnimated: true,
  });

  let touchstartX = 0;
  let touchendX = 0;
  let timeLastSwiped = 0;
  const minTimeBetweenSwipes = 1000;
  const minLengthForSwipe = 30;
  const gestureZone = element;

  gestureZone.addEventListener('touchstart', (event) => {
    touchstartX = event.changedTouches[0].screenX;
  }, passiveSupported ? { passive: true } : false);

  gestureZone.addEventListener('touchend', (event) => {
    touchendX = event.changedTouches[0].screenX;
    handleGesture();
  }, passiveSupported ? { passive: true } : false);

  function handleGesture() {
    const timeNow = new Date().getTime();
    if ((touchendX + minLengthForSwipe) < touchstartX && timeNow > (timeLastSwiped + minTimeBetweenSwipes)) {
      c.next();
      timeLastSwiped = timeNow;
    }

    if (touchendX > (touchstartX + minLengthForSwipe) && timeNow > (timeLastSwiped + minTimeBetweenSwipes)) {
      c.prev();
      timeLastSwiped = timeNow;
    }
  }

  const controlsTopFiddle = 30;
  const slideNavTopFiddle = 4;
  const heightFiddleFactor = 4;

  if (window.innerWidth < 550) {
    // get the max slide height
    const allSlides = element.querySelectorAll('.slide');
    let maxSlideHeight = 0;
    for (let i = 0; i < allSlides.length; i += 1) {
      if (allSlides[i].scrollHeight > maxSlideHeight) {
        maxSlideHeight = allSlides[i].scrollHeight;
      }
    }

    // get the max caption height
    const allCaptions = element.querySelectorAll('.slide-caption');
    let maxCaptionHeight = 0;
    for (let i = 0; i < allCaptions.length; i += 1) {
      if (allCaptions[i].scrollHeight > maxCaptionHeight) {
        maxCaptionHeight = allCaptions[i].scrollHeight;
      }
    }

    // set all the captions to the maximum caption height
    for (let i = 0; i < allCaptions.length; i += 1) {
      allCaptions[i].style.height = `${maxCaptionHeight}px`;
    }

    const controls = element.querySelectorAll('.controls');
    const slidenav = element.querySelector('.slidenav');
    const totalSlideshowHeight = maxSlideHeight + slidenav.scrollHeight + heightFiddleFactor;

    // set the heights for everything
    if (maxSlideHeight > 0) {
      const container = element.querySelector('.carousel');
      container.style.height = `${totalSlideshowHeight}px`;
      for (let i = 0; i < controls.length; i += 1) {
        controls[i].style.top = `${maxSlideHeight + controlsTopFiddle}px`;
      }
      slidenav.style.top = `${maxSlideHeight + slideNavTopFiddle}px`;
    }
  }
}
